<template>
  <rest-page :key="key" ref="restPage" :fetch-endpoint="fetchEndpoint">
    <rest-form
      ref="form"
      :disabled="false"
      :model="model"
      :save-endpoint="saveEndpoint"
      :after-save="afterSave"
    >
      <page-header-new :breadcrumbs="breadcrumbs" :title="title">
        <template slot="actions">
          <el-button icon="el-icon-check" plain type="primary" @click="save">
            <span>{{ saveButtonLabel }}</span>
          </el-button>
        </template>
      </page-header-new>
      <page-content>
        <basic-details :model="model" />
        <target-email-address :model="model" />
        <schedule :model="model" />
      </page-content>
    </rest-form>
  </rest-page>
</template>

<script>
import TargetEmailAddress from '@/modules/campaign-manage/components/report/TargetEmailAddress.vue'
import BasicDetails from '@/modules/campaign-manage/components/report/BasicDetails.vue'
import Schedule from '@/modules/campaign-manage/components/report/Schedule.vue'
import PageContent from '@/common/components/page/PageContent.vue'
import PageHeaderNew from '@/common/components/page/PageHeaderNew.vue'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import RestForm from '@/common/components/rest/RestForm.vue'
import RestPage from '@/common/components/rest/RestPage.vue'
import moment from 'moment'
import RestApi from '@/core/services/RestApi'
export default {
  name: 'CampaignReport',

  components: {
    RestPage,
    RestForm,
    PageHeaderNew,
    PageContent,
    Schedule,
    BasicDetails,
    TargetEmailAddress
  },

  mounted() {
    RestApi(
      projectEndpoint({
        method: 'get',
        url: `campaigns/${this.$route.query.id}`
      })
    )
      .then(({ data }) => {
        this.campaignTitle = data.title
      })
      .catch(data => {
        if (data.message) {
          this.$message({
            message: data.message,
            type: 'error'
          })
        }
      })
  },

  data() {
    return {
      key: '',
      campaignTitle: '',
      model: {
        campaign_id: this.$route.query.id,
        create_time: moment().unix(),
        active: 1,
        title: '',
        delta: Number(this.$hasFeature('saveAsReportDelta')),
        start_from_campaign_creation: Number(
          this.$hasFeature('saveAsReportCampaignStartTime')
        ),
        base_runs: null,
        report_type: this.$route.query.report_type,
        recipients: null,
        schedule: {
          frequency: 'weekly',
          time: '00:00',
          minutes: null,
          day: []
        }
      }
    }
  },

  computed: {
    routeName() {
      return this.$can('updateProjectItem') ? 'UpdateCampaign' : 'ViewCampaign'
    },
    breadcrumbs() {
      if (!this.campaignTitle) {
        return []
      }

      return [
        {
          label: this.$t('Campaigns_Breadcrumb_Campaigns')
        },
        {
          label: this.campaignTitle,
          route: projectRoute({
            name: this.routeName,
            query: { id: this.$route.query.id },
            hash: '#analytics'
          })
        },
        {
          label: this.model.title
        }
      ]
    },

    title() {
      return this.$route.query.report_id
        ? this.$t('CampaignReport_UpdateReport')
        : this.$t('CampaignReport_CreateReport')
    },

    saveButtonLabel() {
      return this.$route.query.report_id
        ? this.$t('RestForm_Update')
        : this.$t('RestForm_Save')
    },

    fetchEndpoint() {
      if (!this.$route.query.report_id) {
        return null
      }

      return projectEndpoint({
        method: 'get',
        url: `campaign/reports/${this.$route.query.report_id}`,
        params: {
          campaign_id: this.$route.query.id
        },
        handler: data => {
          const campaignId = data.campaign_id
          if (campaignId !== this.$route.query.id) {
            this.$router.replace(
              projectRoute({
                name: 'UpdateCampaignReport',
                query: {
                  id: campaignId,
                  report_id: data.id
                }
              })
            )
          }

          if (this.$hasFeature('saveAsReportDelta')) {
            data.delta = 1
          }
          this.model = data
        }
      })
    },

    saveEndpoint() {
      if (this.$route.query.report_id) {
        return projectEndpoint({
          method: 'patch',
          url: `campaign/reports/${this.$route.query.report_id}`,
          data: this.model
        })
      }

      return projectEndpoint({
        method: 'post',
        url: 'campaign/reports',
        data: this.model
      })
    }
  },

  methods: {
    save() {
      this.$refs['form'].save()
    },

    afterSave() {
      this.$router.push(
        projectRoute({
          name: this.routeName,
          query: {
            id: this.$route.query.id,
            tab: 'reports'
          },
          hash: '#analytics'
        })
      )
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/pages/CampaignReport.vue